export type QuoteHistory = {
    id?: number;
    email?: string;
    name?: string;
    contactName?: string;
    singleQuote: QuoteHistoryData | null;
    combinedQuote: QuoteHistoryData | null;
};

export type QuoteHistoryData = {
    id: number;
    out: QuoteData[];
    faceAmount: number;
    monthlyPremium: number;
    lapseAge?: number;
    quoteAge?: number;
    productName: string;
    email: string;
    name: string;
    contactName: string;
    productType: string;
};

export type QuoteData = {
    name: string;
    type: string;
    value: any;
    fieldName?: string;
    contactName?: string;
    field?: string;
};
const categories = [
    'Agent & Product Information',
    'Basic Information',
    'Identity',
    'Beneficiaries',
    'Existing Policies',
    'Personal History',
    'Health',
    'Drug or Alcohol Dependence / Withdrawal',
    'DUI',
    'License',
    'Moving violations',
    'Criminal offense',
    'Bankruptcy',
    'Tobacco & Marijuana',
    'Family History',
    'Physician',
    'Permissions',
    'Policy Information',
    'Conditional Coverage & Banking',
    'Notes',
    'Emergency Contact (VUL Only)',
    'Financials (VUL Only)',
    'Upsell Opportunities',
    'Personal Information',
];

export const Categories = {
    AGENT_INFORMATION: 'Agent & Product Information',
    BASIC_INFORMATION: 'Basic Information',
    IDENTITY: 'Identity',
    BENEFICIARIES: 'Beneficiaries',
    EXISTING_POLICIES: 'Existing Policies',
    FG_PERSONAL: 'Personal History',
    FG_HEALTH: 'Health History',
    EQUITABLEVUL_HEALTH: 'Health',
    HEALTH: 'Health',
    DRUG_OR_ALCOHOL_DEPENDENCE_WITHDRAWAL: 'Drug or Alcohol Dependence / Withdrawal',
    DUI: 'DUI',
    LICENSE: 'License',
    MOVING_VIOLATIONS: 'Moving violations',
    CRIMINAL_OFFENSE: 'Criminal offense',
    BANKRUPTCY: 'Bankruptcy',
    TOBACCO_AND_MARIJUANA: 'Tobacco & Marijuana',
    FAMILY_HISTORY: 'Family History',
    PHYSICIAN: 'Physician',
    PERMISSIONS: 'Permissions',
    POLICY_INFORMATION: 'Policy Information',
    BANKING_INFORMATION: 'Banking Information',
    NOTES: 'Notes',
    EMERGENCY_CONTACT_VUL_ONLY: 'Emergency Contact (VUL Only)',
    FINANCIALS_VUL_ONLY: 'Financials (VUL Only)',
    UPSELL_OPPORTUNITIES: 'Upsell Opportunities',
    PERSONAL_INFORMATION: 'Personal Information',
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Categories = (typeof Categories)[keyof typeof Categories];
